export default class SelectedOption {
  name?: string;
  value?: string;

  constructor(response?: any) {
    if (response != null) {
      this.name = response.name;
      this.value = response.value;
    }
  }
}
